import { DotSeriesLegend } from './DotSeriesLegend/DotSeriesLegend.js';
import { RectLegend } from './RectLegend/RectLegend.js';
import { useXYChartData } from '../../hooks/useXYChartData.js';
import { isRectSeries, isDotSeries } from '../../utils/type-guards.js';

export const XYChartLegend = () => {
  const { seriesWithDatapoints } = useXYChartData();

  const firstSeries = seriesWithDatapoints[0];

  if (isRectSeries(firstSeries)) {
    return <RectLegend series={firstSeries} />;
  } else if (isDotSeries(firstSeries)) {
    return <DotSeriesLegend />;
  }

  return;
};
